<template>
	<div class="call content">
		<component :is="href('/interactions/call/details').content" />
		<div v-if="showDetails">
			<h3><font-awesome-icon icon="phone"/> {{ href('/interactions/call/details').meta.phone }}</h3>
			<span v-if="ring" class="ring">{{ href('/interactions/call/details').meta.ring }}</span><a class="phone" ref="phone"></a>
		</div>
	</div>
</template>

<script>
import hreflang from '@/lib/hreflang'

export default {
	name: 'CallInteraction',
	mixins: [ hreflang ],
	data() {
		return {
			ring: false
		}
	},
	props: {
		showDetails: Boolean,
	},
	created() {
		this.document(require('documents/en/interactions/call-details.md'), 'en')
	},
	mounted() {
		window.whitebox.init('voip', voip => {
			if (voip && this.showDetails) {
				voip.service.call(this.$refs.phone)
				voip.on('voip.ring', () => {
					this.ring = true
				}, this)
			}
		})
	}
}
</script>

<style scoped lang="less">
@import url('~whitebox-presentation/src/assets/variables.less');
@import url('~whitebox-presentation/src/assets/mixins.less');

h3 {
	font-size: @font-size-s;
	margin-top: @gap * 2;
	color: @gray-50;
	font-weight: @normal;
	margin-bottom: 0;
}

.content {
	padding: 0;
}
.phone, .ring {
	.count();
}
.ring + .phone {
	display: none;
}
.whitebox-voip-ready {
	color: white;
}
.whitebox-voip-active {
	color: @black;
}
</style>
